/**
 * Use this as a placeholder value whenever a field/property does not exist, is null or undefined, and
 * situationally (per requirements) if value is empty string, etc. This is logically the "N/A"
 * to be used for tealium integration work.
 */
export const NOT_SET = 'not set';

// Action type to save tealium loaded state in redux
export const TEALIUM_SCRIPT_LOADED = 'tealium_script_loaded';

export const ZIP_CODE_KEY_TO_REMAP = 'zipCode';
export const REMAPPED_ZIP_CODE_KEY = 'zip';
export const PHONE_NUMBER_KEY_TO_REMAP = 'phoneNumber';
export const REMAPPED_PHONE_NUMBER_KEY = 'phone';

// MARK: My account constants
export const ACADEMY = 'academy';

const MYACCOUNT_ORDERS = '/myaccount/orders';
const MYACCOUNT_ADDRESS = '/myaccount/addressBook';
const MYACCOUNT_WISHLIST = '/myaccount/wishlist';
const MYACCOUNT_PROFILE = '/myaccount/profile';
const MYACCOUNT_DELETE_ACCOUNT = '/myaccount/profile/deleteAccount';
const MYACCOUNT_FAVORITES = '/myaccount/yourItems/wishlist/favorites';

// Page Hierarchy map for the my account pages
export const PAGE_HIERARCHY_MAP = {
  [MYACCOUNT_ADDRESS]: 'myaccount > address book',
  [MYACCOUNT_PROFILE]: 'myaccount > account settings',
  [MYACCOUNT_WISHLIST]: 'myaccount > list',
  [MYACCOUNT_ORDERS]: 'myaccount > manage purchases',
  [MYACCOUNT_DELETE_ACCOUNT]: 'myaccount > account settings > delete account',
  [MYACCOUNT_FAVORITES]: 'myaccount > yourItems > favorites',
};

export const MYACCOUNT_PATHS_SPECIAL_ANALYTICS_HANDLING = [
  MYACCOUNT_ADDRESS,
  MYACCOUNT_PROFILE,
  MYACCOUNT_WISHLIST,
  MYACCOUNT_DELETE_ACCOUNT,
  MYACCOUNT_ORDERS,
  MYACCOUNT_FAVORITES,
];

export const GIFT_CARD_OFFER_TYPES = {
  E_GIFT_CARD: 'egift_card',
  PYHSICAL_GIFT_CARD: 'physical_gift _card',
  FREE_GIFT: 'free_gift_product',
};
